import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private msalService: MsalService,
    private router: Router,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
    const requiredRoles: string[] = route.data['roles'] || [];
    const account = this.msalService.instance.getActiveAccount();

    if (!account) {
      return this.router.createUrlTree(['/login']);
    }

    try {
      console.debug(
        '[AuthGuard] canActivate: calling acquireTokenSilent for account:',
        account.username,
      );
      const tokenResult = await this.msalService.instance.acquireTokenSilent({
        scopes: environment.scopes,
        account,
      });

      const claims = tokenResult.idTokenClaims as any;
      const userRoles = claims?.roles || [];

      const hasRequiredRoles =
        requiredRoles.length === 0 || requiredRoles.some(role => userRoles.includes(role));

      return hasRequiredRoles ? true : this.router.createUrlTree(['/forbidden']);
    } catch (err) {
      if (err instanceof InteractionRequiredAuthError) {
        return this.router.createUrlTree(['/login']);
      }
      console.error('Token error:', err);
      return this.router.createUrlTree(['/login']);
    }
  }
}
